import { Common } from '@crops';
import { DefaultValue, selector } from 'recoil';
import CommonApi from 'api/CommonApi';
import { CommonDataState } from 'state/commonState';
import ApiMapper from 'constant/ApiMapper';
import CropApi from 'api/CropApi';
import { emit } from 'process';

const code = ApiMapper;
const bootstrap = code.COMMON.BOOTSTRAP;

const CommonDataQuery = selector<Common.TCommonData | DefaultValue>({
  key: 'CommonDataQuery' /* 기본 데이터 */,
  get: async () => {
    try {
      const ctpv = await CommonApi.ListCtpv({ url: bootstrap.CTPV_LIST });
      const sgg = await CommonApi.ListSgg({ url: bootstrap.SGG_LIST , regionCode: '' });
      const emd = await CommonApi.ListEmd({ url: bootstrap.EMD_LIST, regionCode: '' });
     
      // 재배작물 범례
      const legend_ = await CommonApi.CommonCode('TREE_KIND_CD');

      const sameCd = await CommonApi.CommonCode('SAME_CD');

      const cropsRegKind = await CommonApi.CommonCode('CROPS_REG_KIND');

      const cropsCode = await CommonApi.CommonCode('CROPS_REG_CLS_CD');

      //경작 비경작 정보
      const tillageCode = await CommonApi.CommonCode('TILLAGE_CD');

      return {
        sgg,
        ctpv,
        emd,
        legend: legend_,
        sameCd,
        cropsRegKind,
        cropsCode,
        tillageCode: tillageCode.sort((a, b) => Number()),
      };
    } catch (e: any) {
      alert(e.message);
      console.error(e);
      throw e;
    }
  },
  set: ({ set }, newValue: Common.TCommonData | DefaultValue) => {
    if (newValue instanceof DefaultValue) return;
    console.log('from db ', newValue);
    set(CommonDataState, (prev: any) => ({
      ...prev,
      sgg: newValue.sgg,
      ctpv: newValue.ctpv,
      emd: newValue.emd,
      legend: newValue.legend,
      tillageCode: newValue.tillageCode,
      cropsCode: newValue.cropsCode,
    }));
  },
});

export { CommonDataQuery };
